import { VisitHistory, VisitHistoryQuery } from '@dreryk/egabinet-visit-frontend-api';

import { useCqrsFind } from '@dreryk/command-query-react-common';
import { commonTranslationKeys } from '@dreryk/react-common';
import { LoaderSpinner, Message, MessageType, Redirect } from '@dreryk/react-components';
import { Slot } from '@dreryk/watermelon';

import { visitPaths } from '~libs.desktop.shared.paths';

import { VisitHistoryShowAnnulledCheckbox } from './VisitHistoryShowAnnulledCheckbox/VisitHistoryShowAnnulledCheckbox';

type VisitHistoryPanelLoaderResult = {
   visitHistory: VisitHistory;
};

type VisitHistoryPanelLoaderProps = {
   readonly visitId: number;
   readonly patientId: number;
   readonly children: (result: VisitHistoryPanelLoaderResult) => JSX.Element;
};

export const VisitHistoryPanelLoader = (props: VisitHistoryPanelLoaderProps): JSX.Element => {
   const [includeAnnulled] = VisitHistoryShowAnnulledCheckbox.useAnnulledVisitsVisibilityPreferenceGlobalState();
   const { data: visitHistory, loading: visitHistoryLoading, error: visitHistoryError } = useCqrsFind<VisitHistory>(
      () => {
         const query = new VisitHistoryQuery();
         query.id = Slot.emptyIfNull(props.visitId);
         query.includeAnnulled = includeAnnulled;
         return query;
      }
   );

   if (visitHistoryLoading) {
      return <LoaderSpinner />;
   }

   if (visitHistoryError) {
      return (
         <Message
            testId={'fetchError'}
            type={MessageType.NEGATIVE}
            label={commonTranslationKeys.unexpectedErrorHasOccurred}
            displayIndicator
         />
      );
   }

   if (visitHistory === null) {
      return (
         <Redirect
            path={visitPaths.getVisitHistoryPath({
               params: {
                  patientId: props.patientId,
               },
               searchParams: {},
            })}
         />
      );
   }

   return props.children({
      visitHistory: visitHistory,
   });
};
